import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import {Button} from 'reactstrap';
import {Tabela} from "../../comum/components/Tabela";
import {ModalForm} from "../../comum/components/ModalForm";
import ValidacaoStore from "../../comum/stores/ValidacaoStore";
import FontAwesome from 'react-fontawesome';

@inject("store")
@observer
export class TabelaCadastro extends Component {

    @observable cadastrando;
    @observable editando;

    constructor(props) {
        super(props);
        this.acaoCadastrar  = this.acaoCadastrar.bind(this);
        this.acaoEditar     = this.acaoEditar.bind(this);
        this.acaoRemover    = this.acaoRemover.bind(this);
        this.modalStore     = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.appStore       = this.props.store.appStore;
        this.editar         = this.editar.bind(this);
        this.cadastrar      = this.cadastrar.bind(this);
        this.cadastrando = false;
        this.editando = false;
    }

    /* qual modal renderizar */
    modalForm(){
        if (this.modalStore.exibirModal.aberto) {

            switch (this.modalStore.exibirModal.tipo) {
                case 'cadastrar':
                    return (
                        <ModalForm
                            corpo={this.props.modalCadastrar}
                            cabecalho={this.props.nomeCadastro +": Novo"}
                            botoes={this.botoesModalCadastrar()}  />
                    );
                case 'editar':
                    return (
                        <ModalForm
                            corpo={this.props.modalEditar}
                            cabecalho={this.props.nomeCadastro +": Editar"}
                            botoes={this.botoesModalEditar()} />
                    );
                case 'remover':
                    return (
                        <ModalForm
                            corpo={this.modalRemover()}
                            cabecalho={this.props.nomeCadastro +": Remover"}
                            botoes={this.botoesModalRemover()} />
                    );
            }
        }
    }

    modalRemover = () => {
        return(
            <div>
                <span>Deseja realmente excluir esse item?</span>
            </div>
        )
    };

    editar() {
        if(!this.editando) {
            this.modalStore.setSubmitted(true);
            this.modalStore.setSubmitMensagemErro("");
            this.modalStore.loading = true;
            this.editando = true;
            if (this.validacaoStore.isValidForm) {
                const promise = this.props.editar();
                if (promise) {
                    promise.then(response => {
                        this.modalStore.loading = false;
                        this.editando = false;
                        this.modalStore.toggleModal();
                    }).catch(error => {
                        this.modalStore.loading = false;
                        this.editando = false;
                        this.modalStore.setSubmitMensagemErro(error.response.data.message);
                    });
                }
            } else {
                this.editando = false;
                this.modalStore.loading = false;
            }
        }
    }

    cadastrar() {
        if(!this.cadastrando) {
            this.modalStore.loading = true;
            this.modalStore.setSubmitted(true);
            this.modalStore.setSubmitMensagemErro("");
            this.cadastrando = true;
            if (this.validacaoStore.isValidForm) {
                const promise = this.props.cadastrar();
                if (promise) {
                    promise.then(response => {
                        this.cadastrando = false;
                        this.modalStore.loading = false;
                        this.modalStore.toggleModal();
                    }).catch(error => {
                        this.modalStore.loading = false;
                        this.cadastrando = false;
                        this.modalStore.setSubmitMensagemErro(error.response.data.message);
                    });
                }
            } else {
                this.cadastrando = false;
                this.modalStore.loading = false;
            }
        }
    }

    botoesModalEditar(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.editar()}>Salvar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalCadastrar(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.cadastrar()}>Salvar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    botoesModalRemover(){
        return (<div>
            <Button color="danger" disabled={this.modalStore.loading} onClick={() => {this.props.remover()}}>Remover</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Cancelar</Button>
        </div>)
    }

    acaoMobile(row, tipo) {
        this.props.preencherModal(row);
        this.modalStore.toggleModal(tipo);
    }

    acaoLinha = (row, tipo) => {
        this.props.preencherModal(row);
        this.modalStore.toggleModal(tipo);
    };

    /* Implementar Ações dos Botões */
    botaoLinhaTabela = (row, itemAcao, i, tipo) => {
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        return <a key={i}
                   className={"btn btn-secondary " + buttonType + itemAcao.cor}
                   title={itemAcao.label}
                   onClick={() => {this.acaoLinha(row, tipo)}}>
                    <FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/>
                </a>
    }

    acaoCadastrar(){
        this.props.preencherModal();
        this.modalStore.toggleModal('cadastrar');
    }

    acaoEditar(row, itemAcao, i){
        return this.botaoLinhaTabela(row, itemAcao, i, 'editar');
    }

    acaoRemover(row, itemAcao, i){
        return this.botaoLinhaTabela(row, itemAcao, i, 'remover');
    }
    /* fim: Ações dos Botões */

    render() {

        /* Especificar Botões no topo da TabelaStore (Se houverem) */
        const botoes = [
            { label: "Novo",
                acao: this.acaoCadastrar
            }
        ];

        /* Especificar botões nos itens da tabela (Se houverem) */
        const acoesItens = this.props.criarNovos ? [
            {
                label: "Editar",
                icone: "edit",
                acao: this.acaoEditar
            },{
                label: "Remover",
                icone: "trash",
                cor: "text-danger",
                acao: this.acaoRemover
            }
        ] : [
            {
                label: "Editar",
                icone: "edit",
                acao: this.acaoEditar
            }
        ];
        return (
            <div>
                <Tabela
                    listaItens={this.props.listaItens}
                    useCardsMobile={true}
                    colunas={this.props.colunas}
                    botoes={this.props.criarNovos ? botoes : []}
                    temBusca={this.props.temBusca}
                    acoesItens={acoesItens}
                    tituloMobile={this.props.tituloMobile}
                    conteudoMobile={this.props.conteudoMobile}
                    extraMobile={this.props.extraMobile}
                    onChange={this.props.onChange}
                    onCardClick={(row) => this.acaoMobile(row, 'editar')}
                    loading={this.props.loading}
                    mobileFilter={this.props.mobileFilter}
                />
                {this.modalForm()}
            </div>

        );
    }
}